import { registerPlugin } from "@capacitor/core";

interface WGAndroidConfigPlugin {
  getDeviceKey(): Promise<{ value: string }>;
}

const WGAndroidConfig = registerPlugin<WGAndroidConfigPlugin>("WGAndroidConfig");

export async function getNativeAndroidDeviceKey(): Promise<string> {
  try {
    const result = await WGAndroidConfig.getDeviceKey();
    if (result.value.trim()) return result.value.trim();
  } catch {
    // No navegador comum o plugin nativo não existe.
  }

  return String(import.meta.env.VITE_ANDROID_DEVICE_KEY ?? "").trim();
}
